/* ============================================================
   THE MONEY–BODY CODE · ATMOSPHERE ENGINE
   Auto-initialises ambient canvases. Loaded once from layout/theme.liquid:
     <script src="{{ 'atmosphere.js' | asset_url }}" defer></script>
   (gated on the "Enable atmosphere effects" theme setting).

   Mark any .mbc-atmos layer with data-mbc tokens:
     data-mbc="particles"   → slow drifting gold particles
     data-mbc="coderain"    → subtle gold "body code" rain
     data-mbc="glow"        → CSS orbs (handled in atmosphere.css)
   Tokens can combine: data-mbc="glow particles".
   Optional: data-count="30", data-color="#E2BF6A".
   ============================================================ */
(function(){
  const GOLD = '#E2BF6A', INK = '#0A0809';
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function hexRGB(h){ return [1,3,5].map(i=>parseInt(h.slice(i,i+2),16)); }

  /* ── drifting gold particles (calm) ── */
  function particles(host, count, color){
    const canvas=document.createElement('canvas'); host.appendChild(canvas);
    const ctx=canvas.getContext('2d'); const [R,G,B]=hexRGB(color);
    let w,h,parts;
    function init(){ w=canvas.width=host.clientWidth||host.offsetWidth;
      h=canvas.height=host.clientHeight||host.offsetHeight; parts=[];
      for(let i=0;i<count;i++) parts.push({x:Math.random()*w,y:Math.random()*h,
        size:Math.random()*2+.5, sy:-(Math.random()*.13+.035), sx:(Math.random()-.5)*.05,
        op:Math.random()*.4+.1, ph:Math.random()*Math.PI*2, ps:Math.random()*.012+.003}); }
    function frame(){ ctx.clearRect(0,0,w,h);
      for(const p of parts){ p.x+=p.sx;p.y+=p.sy;p.ph+=p.ps; const a=p.op*(Math.sin(p.ph)*.15+.85);
        if(p.y<-10){p.y=h+10;p.x=Math.random()*w;} if(p.x<-10)p.x=w+10; if(p.x>w+10)p.x=-10;
        ctx.beginPath();ctx.arc(p.x,p.y,p.size,0,Math.PI*2);ctx.fillStyle=`rgba(${R},${G},${B},${a})`;ctx.fill();
        const g=ctx.createRadialGradient(p.x,p.y,0,p.x,p.y,p.size*3);
        g.addColorStop(0,`rgba(${R},${G},${B},${a*.3})`);g.addColorStop(1,`rgba(${R},${G},${B},0)`);
        ctx.beginPath();ctx.arc(p.x,p.y,p.size*3,0,Math.PI*2);ctx.fillStyle=g;ctx.fill(); }
      requestAnimationFrame(frame); }
    init(); if(!reduce) frame(); window.addEventListener('resize',init);
  }

  /* ── subtle gold "body code" rain ── */
  function coderain(host){
    const canvas=document.createElement('canvas'); host.appendChild(canvas);
    const ctx=canvas.getContext('2d');
    const GLYPHS='01001011010011010001', FS=15, GAP=2.7;
    let w,h,cols,drops,speeds;
    function init(){ w=canvas.width=host.clientWidth||host.offsetWidth;
      h=canvas.height=host.clientHeight||host.offsetHeight;
      const step=FS*GAP; cols=Math.floor(w/step); drops=[]; speeds=[];
      for(let i=0;i<cols;i++){ drops[i]=(Math.random()*2-1)*(h/FS); speeds[i]=Math.random()*0.20+0.12; } }
    init(); window.addEventListener('resize',init);
    if(reduce){
      ctx.font=`${FS}px ui-monospace, Menlo, monospace`; const step=FS*GAP;
      for(let i=0;i<cols;i++) for(let j=0;j<h/FS;j++){ if(Math.random()>0.3) continue;
        ctx.fillStyle=`rgba(201,162,78,${Math.random()*0.26+0.05})`;
        ctx.fillText(GLYPHS[(Math.random()*GLYPHS.length)|0], i*step, j*FS); }
      return;
    }
    let last=0; const INTERVAL=1000/20;
    function frame(t){ requestAnimationFrame(frame); if(t-last<INTERVAL) return; last=t;
      ctx.fillStyle='rgba(10,8,9,0.10)'; ctx.fillRect(0,0,w,h);
      ctx.font=`${FS}px ui-monospace, "SF Mono", Menlo, monospace`; const step=FS*GAP;
      for(let i=0;i<cols;i++){ const x=i*step, y=drops[i]*FS;
        ctx.fillStyle='rgba(226,191,106,0.38)'; ctx.shadowColor='rgba(226,191,106,0.35)'; ctx.shadowBlur=5;
        ctx.fillText(GLYPHS[(Math.random()*GLYPHS.length)|0], x, y); ctx.shadowBlur=0;
        ctx.fillStyle='rgba(154,117,53,0.13)';
        ctx.fillText(GLYPHS[(Math.random()*GLYPHS.length)|0], x, y-FS);
        drops[i]+=speeds[i];
        if(y>h && Math.random()>0.94){ drops[i]=Math.random()*-20; speeds[i]=Math.random()*0.20+0.12; } } }
    requestAnimationFrame(frame);
  }

  function initEl(el){
    if(el.__mbcAtmos) return; el.__mbcAtmos=true;      // guard double-init
    const tokens=(el.dataset.mbc||'').split(/\s+/);
    const count=parseInt(el.dataset.count||'30',10);
    const color=el.dataset.color||GOLD;
    if(tokens.includes('particles')) particles(el, count, color);
    if(tokens.includes('coderain'))  coderain(el);
    /* 'glow' is pure CSS (atmosphere.css) */
  }
  function boot(root){
    (root||document).querySelectorAll('.mbc-atmos[data-mbc]').forEach(initEl);
  }
  /* expose so React/component code can init a freshly-mounted node */
  window.MBCAtmosphere = { boot, initEl };
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', ()=>boot()); else boot();
})();
